import { useLocale } from '@/helpers/LangHelper';

import styles from './search-bar.module.scss';
import { SearchBarV3 } from './search-bar-v3';

const hideSearchOnTheseLocales: string[] = ['fr-FR', 'es-ES', 'it-IT'];

const SearchBar = () => {
  const { locale } = useLocale();

  if (hideSearchOnTheseLocales.includes(locale)) {
    return null;
  }

  return (
    <div className={styles.searchInputWrapper}>
      <SearchBarV3 />
    </div>
  );
};

export default SearchBar;
